<h1 mat-dialog-title>{{'Pages.OrderType.Title' | translate}}</h1>
<div mat-dialog-content>
    <mat-divider></mat-divider>
    <div *ngIf="orderData?.Balcony" matRipple class="no-outline pointer-cursor" (click)="setOrderType(1)">
        <div class="small-margin small-padding">
            <div class="label">{{'Pages.OrderType.Balcony.Title' | translate}}</div>
            <div class="detail">{{'Pages.OrderType.Balcony.Description' | translate}} {{orderData.BalconyWaitTime}}</div>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div *ngIf="orderData?.Delivery" matRipple class="no-outline pointer-cursor"(click)="setOrderType(2)">
        <div class="small-margin small-padding">
            <div class="label">{{'Pages.OrderType.Delivery.Title' | translate}}</div>
            <div class="detail">{{'Pages.OrderType.Delivery.Description' | translate}} {{orderData.DeliveryWaitTime}}</div>
            <div *ngIf="orderData?.HasFloor === true" class="detail small-margin">{{'Pages.OrderType.Delivery.MinimumOrder' | translate}} {{orderData.FloorValueString}}</div>
            <div *ngIf="orderData?.HasFee === true" class="detail small-margin">{{'Pages.OrderType.Delivery.DeliveryFee' | translate}} {{orderData.FeeString}}</div>
            <div *ngIf="orderData?.HasFee === false" class="detail small-margin">{{'Pages.OrderType.Delivery.NoTax' | translate}}</div>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div *ngIf="orderData?.WillComeHere" matRipple class="no-outline pointer-cursor" (click)="setOrderType(3)">
        <div class="small-margin small-padding">
            <div class="label">{{'Pages.OrderType.WillComeHere.Title' | translate}}</div>
            <div class="detail">{{'Pages.OrderType.WillComeHere.Description' | translate}} {{orderData.WillComeHereWaitTime}}</div>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div *ngIf="orderData?.Drive" matRipple class="no-outline pointer-cursor" (click)="setOrderType(4)"> 
        <div class="small-margin small-padding">
            <div class="label">{{'Pages.OrderType.Drive.Title' | translate}}</div>
            <div class="detail">{{'Pages.OrderType.Drive.Description' | translate}} {{orderData.DriveWaitTime}}</div>
        </div>
        <mat-divider></mat-divider>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="" cdkFocusInitial>{{'Pages.OrderType.Return' | translate}}</button>
</div>